export default {
  ok: 'OK',
} as const;
